import { Component } from '@angular/core';
import { FINANCE_ADVANCE_REPORT_URL } from 'src/app/onelog/common/config/url';
import { RequestService } from 'src/app/onelog/services/request.service';
import {
  PAGE_SIZE,
  MAX_SIZE,
  CURRENCY_SYMBOL,
} from 'src/app/onelog/common/config/common';
import { SELECT_TYPE_DROP_DOWN_OPTIONS } from 'src/app/onelog/common/config/dropdown-config';

@Component({
  selector: 'app-finance-advance',
  templateUrl: './finance-advance.component.html',
  styleUrls: ['./finance-advance.component.css'],
})
export class FinanceAdvanceComponent {
  products: any = [];
  pageSize: number = PAGE_SIZE;
  maxSize: number = MAX_SIZE;
  totalProducts: number = 0;
  perPage: number = 0;
  lastPage: number = 0;
  currentPage: number = 0;
  selectedproductId: string = '';
  selectTypeDropDownOptions: any = SELECT_TYPE_DROP_DOWN_OPTIONS;
  publishedDateSelectedFilterData: any = [];

  currencySymbol: any = CURRENCY_SYMBOL;

  constructor(private requestService: RequestService) {}

  ngOnInit() {
    this.getData(FINANCE_ADVANCE_REPORT_URL, this.createPostData());
  }

  getData(
    url: string = FINANCE_ADVANCE_REPORT_URL,
    data: any = [],
    urlParams: string = ''
  ) {
    this.requestService
      .postRequest(url, data, urlParams)
      .subscribe((data: any) => {
        console.log(data);
        this.products = data.data;
        this.totalProducts = data.total;
        this.perPage = data.per_page;
        this.lastPage = data.last_page;
        this.currentPage = data.current_page;
      });
  }

  createPostData() {
    return {
      selectedproductId: this.selectedproductId,
      selectedPublishedDate: Object.assign(
        {},
        this.publishedDateSelectedFilterData
      ),
    };
  }

  updateSelectedType(event: any) {
    if (event.name == 'publishedDate') {
      this.publishedDateSelectedFilterData['selectedFilterType'] =
        event.selectedOption;
    }
  }

  updateSelectedDate(event: any) {
    if (event.type == 'publishedDate') {
      this.publishedDateSelectedFilterData['date'] = event.dateString;
    }
  }

  search() {
    this.getData(FINANCE_ADVANCE_REPORT_URL, this.createPostData());
  }

  //Download Report
  downloadReport() {
    this.requestService.download(
      FINANCE_ADVANCE_REPORT_URL,
      this.createPostData(),
      '/?is_download=1',
      `FINANCE_ADVANCE_REPORT_${Date()}`
    );
  }

  updatePageData(event: Event) {
    let eventData: any = event;
    console.log(eventData.currentPage);
    let urlParams = '?page=' + eventData.currentPage;
    this.getData(FINANCE_ADVANCE_REPORT_URL, this.createPostData(), urlParams);
  }
}
